<div
  class="flex select-none items-center gap-2 rounded-full bg-steel-blue-500 px-2 text-white"
>
  <p
    class="max-w-[30ch] flex-grow overflow-x-hidden text-ellipsis whitespace-nowrap"
  >
    {{ label }}
  </p>
  @if (canRemove) {
    <p class="cursor-pointer" (click)="handleRemoveClicked()">×</p>
  }
</div>
